export default __webpack_public_path__ + "static/negative-former-eksempel1-57827dc0afdaf35c0f180b4f6b2589ee.png";